//EntryFormContent.jsx
import React, { useEffect, useState } from "react";
import { HeroiconsOutlineCalendar } from "../../assets/icons/LayoutIcon";
import {
  DOCTOR,
  PRODUCTCODE,
  PRODUCTNAME,
  STATUS,
} from "../../constants/fetchData";
import {
  getDoctorsForApplicationSale,
  RetrieveItemGroups,
} from "../../services/applicationReport";
import { getDistributorNames } from "../../Common/functions";
import SearchableDropdown from "../Layout/SearchableDropdown";
// import SearchableDropdown from "./SearchableDropdown"; // Import the new component

const EntryFormContent = ({
  formData,
  handleChange,
  handleSubmit,
  handleCancel,
  heading,
  productGroupList,
  setProductGroupList,
  doctorsNameList,
  setDoctorsNameList,
  productNameOptions,
  setProductNameOptions
}) => {
  const distributorsList = getDistributorNames();
  console.log("distributorsList", distributorsList);

  const getProductGroup = async () => {
    let result = [];
    result = await RetrieveItemGroups(1747653662341);
    const groups = result?.data?.text?.itemgroups || [];
    setProductGroupList(groups);
    console.log(result?.data?.text?.itemgroups);
  };

  const getDoctors = async (distributorName) => {
    let result = [];
    // Use the provided distributor name or default to the first one
    const selectedDistributor = distributorName || getDistributorNames()[0];
    console.log("Fetching doctors for distributor:", selectedDistributor);
    result = await getDoctorsForApplicationSale(
      { Distributor_Name: selectedDistributor }
    );
    console.log("Doctors result:", result?.data?.records);
    setDoctorsNameList(result?.data?.records || []);
  };

  useEffect(() => {
    getProductGroup();
    getDoctors();
  }, []);

  // Initialize product name options when product_group is already set (edit mode)
  useEffect(() => {
    if (formData.product_group && productGroupList.length > 0) {
      const selectedGroup = productGroupList.find(
        (group) => group.group_name === formData.product_group
      );
      if (selectedGroup && selectedGroup.items) {
        setProductNameOptions(selectedGroup.items);
      }
    }
  }, [formData.product_group, productGroupList]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    console.log("handleFieldChange called:", name, value);

    // If product group changes, update product name options and reset selection
    if (name === "product_group") {
      const selectedGroup = productGroupList.find(
        (group) => group.group_name === value
      );
      setProductNameOptions(selectedGroup?.items || []);
      handleChange({
        target: { name: "product_group", value: value },
      });
    } else if (name === "product_id") {
      // When product name changes, just update the value
      handleChange({
        target: { name: "product_id", value: value },
      });
    } else if (name === "distributor_name") {
      console.log("Distributor changing to:", value);
      // Update the parent state first
      handleChange(e);
      
      // Fetch doctors for the new distributor
      if (value) {
        console.log("Calling getDoctors with:", value);
        getDoctors(value);
      } else {
        // If no distributor selected, clear doctors list
        console.log("Clearing doctors list");
        setDoctorsNameList([]);
      }
    } else if (name === "tracking_status") {
      // When tracking_status changes, handle it properly
      handleChange(e);
    } else if (name === "doctorsname") {
      const selectedDoctor = doctorsNameList.find(
        (doctor) => doctor.Full_Name === value
      );
      console.log("selectedDoctor", selectedDoctor);
      handleChange(e);
    } else {
      handleChange(e);
    }
  };

  // Get today's date in YYYY-MM-DD format for dates input max
  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  return (
    <div className="flex flex-col h-full relative ">
      {/* Header area */}
      <div className="sticky top-0 bg-white z-10 pt-6 w-full">
        <div className="flex justify-between items-center">
          <h1 className="text-text1 text-2xl sm:text-3xl font-bold">
            {heading}
          </h1>
          <div className="hidden sm:block">
            <button
              onClick={handleSubmit}
              className="text-white bg-primary px-4 py-3 rounded-md"
            >
              Submit
            </button>
          </div>
        </div>
        <hr className="mt-5 mb-4" />
      </div>
      <div className="flex-1 overflow-x-hidden pb-24 sm:pb-8">
        <div className="space-y-6">
          {/* Product Details Section */}
          <div className="text-text1 text-xl font-bold">
            <h1>Product Details</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              {/* Status Dropdown */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text">
                  Status <span className="text-red-500">*</span>
                </label>
                <div className="primary-dropdown mt-1">
                  <select
                    name="tracking_status"
                    className="rounded px-1 text-sm font-normal text-text1 uppercase focus:outline-none focus:ring-0 w-full"
                    value={formData.tracking_status}
                    onChange={handleFieldChange}
                    required
                  >
                    <option value="">Select Status</option>
                    {STATUS.map((tracking_status) => (
                      <option key={tracking_status} value={tracking_status}>{tracking_status}</option>
                    ))}
                  </select>
                </div>
              </div>
              
              {/* Product Group Dropdown - Now Searchable */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Product Group <span className="text-red-500">*</span>
                </label>
                <SearchableDropdown
                  options={productGroupList}
                  value={formData.product_group}
                  onChange={handleFieldChange}
                  name="product_group"
                  placeholder="Select a product group"
                  searchPlaceholder="Search product groups..."
                  optionKey="group_name"
                  optionLabel="group_name"
                  required
                  noOptionsMessage="No product groups found"
                />
              </div>

              {/* Product Name Dropdown - Only show if tracking_status is not Lead */}
              {formData.tracking_status && formData.tracking_status !== "Lead" && (
                <div className="flex-1">
                  <label className="font-medium text-sm leading-5 text-text2">
                    Product Name <span className="text-red-500">*</span>
                  </label>
                  <SearchableDropdown
                    options={productNameOptions}
                    value={formData.product_id}
                    onChange={handleFieldChange}
                    name="product_id"
                    placeholder="Select a product"
                    searchPlaceholder="Search products..."
                    optionKey="item_id"
                    optionLabel="name"
                    required={formData.tracking_status !== "Lead"}
                    disabled={!formData.product_group}
                    noOptionsMessage="No products found"
                  />
                  {!formData.product_group && (
                    <p className="text-xs text-gray-500 mt-1">Please select a product group first</p>
                  )}
                </div>
              )}

              {/* Quantity Input */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Quantity <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  name="quantity"
                  placeholder="Eg:5"
                  className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                  value={formData.quantity}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, "");
                    if (onlyNums.length <= 10) { // Reasonable limit for quantity
                      handleChange({
                        target: {
                          name: e.target.name,
                          value: onlyNums,
                        },
                      });
                    }
                  }}
                  required
                />
              </div>

              {/* Distributor Name Dropdown - Temporary regular select for debugging */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Select Distributor
                </label>
                <div className="mt-1">
                  <select
                    name="distributor_name"
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                    value={formData.distributor_name}
                    onChange={handleFieldChange}
                    style={{ minHeight: '38px' }}
                  >
                    <option value="">Select Distributor</option>
                    {distributorsList.map((distributor, index) => (
                      <option key={index} value={distributor}>{distributor}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Doctor Name Dropdown - Now Searchable */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Doctor Name <span className="text-red-500">*</span>
                </label>
                <SearchableDropdown
                  options={doctorsNameList}
                  value={formData.doctorsname}
                  onChange={handleFieldChange}
                  name="doctorsname"
                  placeholder={formData.distributor_name ? "Select a doctor" : "Select distributor first"}
                  searchPlaceholder="Search doctors..."
                  optionKey="Full_Name"
                  optionLabel="Full_Name"
                  required
                  disabled={!formData.distributor_name}
                  noOptionsMessage={formData.distributor_name ? "No doctors found for this distributor" : "Please select a distributor first"}
                />
                {!formData.distributor_name && (
                  <p className="text-xs text-gray-500 mt-1">Please select a distributor first</p>
                )}
              </div>
            </div>
            <hr className="mt-6 mb-6" />
          </div>

          {/* Patient Details Section */}
          <div className="text-text1 text-xl font-bold">
            <h1>Patient Details</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              {/* Patient Name Input */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Patient Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="patientname"
                  placeholder="Enter name"
                  className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                  value={formData.patientname}
                  onChange={handleChange}
                  required
                  maxLength={100}
                />
              </div>
              {/* Patient Email Address Input */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Patient Email Address
                </label>
                <input
                  type="email"
                  name="patientemail"
                  placeholder="Enter email address"
                  className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                  value={formData.patientemail}
                  onChange={handleChange}
                />
              </div>

              {/* Patient Phone Number Input */}
              <div className="flex-1">
                <label className="font-medium text-sm leading-5 text-text2">
                  Patient Phone No
                </label>
                <input
                  type="text"
                  name="patientnumber"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="Enter phone number"
                  className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                  value={formData.patientnumber}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, "");
                    if (onlyNums.length <= 15) {
                      handleChange({
                        target: {
                          name: e.target.name,
                          value: onlyNums,
                        },
                      });
                    }
                  }}
                />
              </div>
              {/*  Date */}
              <div className="flex-1">
                <label htmlFor="date" className="primary_label font-medium text-sm leading-5 text-text2">
                  Date <span className="text-red-500">*</span>
                </label>
                <div className="relative mt-1">
                  <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                    <HeroiconsOutlineCalendar className="text-md text-gray-500" />
                  </div>
                  <div className="pl-10">
                    <input
                      type="date"
                      id="date"
                      name="dates"
                      className="w-full custom-dateinput border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                      value={formData.dates}
                      onChange={handleChange}
                      max={getTodayDate()}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed button container at the bottom for mobile */}
      <div className="block sm:hidden ">
        <div className=" absolute bottom-0 left-0 right-0 z-10 bg-white opacity-85 border-gray-200  flex justify-end py-2 gap-2">
          <button
            onClick={handleCancel}
            className="text-text1 bg-white border border-gray-300 px-3 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="text-white bg-primary px-3 py-2 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EntryFormContent;